import { ContactInfo } from "@/components/contact/ContactInfo";
import { ContactForm } from "@/components/contact/ContactForm";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="page-transition">
      {/* Hero Section */}
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="max-w-3xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-4">
              Contact Us
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none text-slate-900 font-['Outfit'] mb-6">
              Let's Start a Conversation
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed font-['Plus_Jakarta_Sans']">
              Ready to transform your business with technology? Get in touch with our team 
              to discuss your needs and explore how we can help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="bg-slate-50 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <ContactInfo />
            <ContactForm />
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">
            Our Location
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-white font-['Outfit'] mb-8">
            Visit Our Office
          </h2>
          <div className="aspect-[21/9] bg-slate-800 border border-slate-700 overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3344.5!2d-96.82!3d33.08!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDA0JzQ4LjAiTiA5NsKwNDknMTIuMCJX!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Nidus Technologies Office Location"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}
